import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/userActivations',
        name: 'userActivations',
        meta: { sideMenuLabel: "User Activations", sideMenuIcon: "icon-person-check" },
        component: () => import("./views/userActivations.vue")
    },
    {
        path: '/userActivations/:identifier',
        name: 'userActivationsDetail',
        meta: { sideMenuLabel: "User Activations" },
        component: () => import("./views/userActivationsDetail.vue")
    }
];

export default routes;
